module.exports = __webpack_public_path__ + "static/media/корридор гг 5.52a5efdb.jpg";